import React, { useState, useEffect, useRef, useCallback, ReactNode, PropsWithChildren } from 'react';
import { useClickOutside } from '@/utils/hooks';
import { classnames } from '@/utils/html';
import theme from './NavigationContextMenu.module.scss';
import NavigationContextMenuContext, { NavigationContextMenuContextData } from './NavigationContextMenuContext';

export interface NavigationContextMenuProps extends PropsWithChildren {
    open: boolean;
    element: ReactNode;
    toggle(open: boolean): void;
    // position?: 'bottom' | 'right';
    className?: string;
    menuClassName?: string;
    buttonClassName?: string;
    fillContainer?: boolean;
    size?: 'fit' | 'parent' | 'normal' | 'large';
    direction?: 'left' | 'right';
    noIcons?: boolean;
}

const NavigationContextMenu: React.FC<NavigationContextMenuProps> = ({
    children,
    element,
    toggle,
    open,
    // position = 'bottom',
    className,
    menuClassName,
    buttonClassName,
    size = 'normal',
    noIcons = false,
    direction = 'left',
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const clickOutsideHandler = useCallback((e: MouseEvent) => toggle(false), [toggle]);

    useClickOutside(ref, clickOutsideHandler);

    const [context, setContext] = useState<NavigationContextMenuContextData>({
        toggle,
        open: open,
    });

    useEffect(() => {
        setContext({ toggle, open });
    }, [toggle, open]);

    // const [loaded, setLoaded] = useState(false);
    // useEffect(() => {
    //     if (open) {
    //         setLoaded(true);
    //     }
    // }, [open]);

    return (
        <NavigationContextMenuContext.Provider value={context}>
            <div ref={ref} className={classnames(theme.container, className)}>
                <button
                    type="button"
                    className={classnames(theme.dropdownButton, buttonClassName)}
                    onClick={(e) => toggle(!open)}>
                    {element}
                </button>

                <div
                    className={classnames(theme.dropdownMenu, theme[direction], theme[size], menuClassName, {
                        [theme.noIcons]: noIcons,
                        [theme.open]: open,
                    })}>
                    {children}
                </div>
            </div>
        </NavigationContextMenuContext.Provider>
    );
};

export default NavigationContextMenu;

